import DOMPurify from "dompurify";
import cn from "classnames";
import commonStyles from "../../../../styles.scss";
import { StructuredBlockRowProps } from "./types";
import styles from "./styles.scss";

export const StructuredBlockRow = ({
  title,
  text,
}: StructuredBlockRowProps) => (
  <div className={styles.row}>
    <p
      className={cn(styles["row-title"], commonStyles["size-medium-long"])}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(title),
      }}
    />
    <p
      className={cn(styles["row-desc"], commonStyles["size-medium-long"])}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(text),
      }}
    />
  </div>
);
